import { IoClose } from "react-icons/io5";
import { FaDownload, FaFileWord } from "react-icons/fa";
import "./styles/FilePreviewModal.css";

export default function FilePreviewModal({ isOpen, onClose, onDownload }) {
  if (!isOpen) return null;

  return (
    <div className="doc-preview-overlay" onClick={onClose}>
      <div className="doc-preview-popup" onClick={(e) => e.stopPropagation()}>
        <button className="doc-preview-close" onClick={onClose}>
          <IoClose />
        </button>
        <FaFileWord className="doc-preview-icon" />
        <h2>Preview Not Available</h2>
        <p>Microsoft Word documents cannot be previewed in the browser.</p>
        <button className="doc-preview-download" onClick={onDownload}>
          <FaDownload />
          Download Document
        </button>
      </div>
    </div>
  );
}
